// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"d981a8aa","453":"8ab44547","905":"f46755b6"}[chunkId] + ".chunk.js";
};